import { LazyModule } from 'owa-bundling';

export const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "ForgottenAttachments" */ './lazyIndex')
);

// Nothing to export as this package subscribes orchestrators to some actions
